var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uni-modal',{attrs:{"title":_vm.$t('pricing.title'),"is-visible":_vm.modalSub},on:{"close-modal":function($event){_vm.modalSub = false}},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('handle-subscription',{attrs:{"capsule-id":_vm.capsuleId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }